import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any
@Component({
  selector: 'app-new-case',
  templateUrl: './new-case.component.html',
  styleUrls: ['./new-case.component.scss']
})
export class NewCaseComponent implements OnInit {

  isPopupMode = false
  isAddMode = false
  isNewCaseForContactId = false
  isViewMode = false
  isShowAnswerLink = false
  isEndCase = false
  isNewCaseForChatbot = false

  kmCriteria = ""
  matchKmType: any
  matchKm: any
  kmList: any
  showingKBList: any = []

  role: any = {}
  cookieData: any
  myTeams: any

  newContact: boolean
  form: FormGroup
  submitted = false

  caseChannelList: any
  caseStatusList: any
  caseSeverityList: any

  // smsTmpList: any
  // emailTmpList: any
  caseTypeList: any
  subTypeTmpList: any
  caseSubTypeList: any = []
  subTypeDetailTmpList: any
  caseSubTypeDetailList: any = []

  createdon: any
  modifiedon: any
  createBy = ""
  modifiedBy = ""

  id: string = ""
  guid: string = ""
  teamList: any

  isEditMode = false

  agentList: any = []
  userIdReceive = ""
  userList: any = []
  contactList: any = []
  forwardRemark = ""
  submittedForward = false
  forwardTeam: any

  dpa_pdpa_flag = false
  isRemarkRequired = false
  isResolvedRequired = false

  dpa_casechannelid: string

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private util: UtilService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {

    this.form = this.fb.group({
      contactid: "",
      dpa_contacttype: "",
      firstname: ['', Validators.required],
      lastname: "",
      dpa_idcard: "",
      dpa_passport: "",
      birthdate: "",
      dpa_companyname: "",
      dpa_registrationdate: "",
      dpa_authorizedperson: "",
      dpa_authorizedperson_idcard: "",
      dpa_authorizedperson_telephone: "",
      telephone1: ['', Validators.required],
      dpa_otherphone: "",
      emailaddress1: ['', this.emailValidator],
      dpa_contact_homeno: "",
      dpa_contact_building: "",
      dpa_contact_moo: "",
      dpa_contact_street: "",
      dpa_contact_subdistict: "",
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",
      dpa_contact_country: "",
      dpa_registration_homeno: "",
      dpa_registration_building: "",
      dpa_registration_moo: "",
      dpa_registration_street: "",
      dpa_registration_subdistict: "",
      dpa_registration_distict: "",
      dpa_registration_province: "",
      dpa_registration_postcode: "",
      dpa_registration_country: "",
      dpa_dopaflag: "",
      dpa_ndidflag: "",
      dpa_agentbankflag: "",
      dpa_verifydate: "",
      dpa_facebookflag: "",
      dpa_googleflag: "",
      dpa_lineflag: "",
      statusreason: "",

      incidentid: "",
      ticketnumber: "",
      title: "",
      customerid: "",
      dpa_casetypeid: ['', Validators.required],
      dpa_casesubtypeid: ['', Validators.required],
      dpa_casesubtypedetailid: ['', Validators.required],
      dpa_casechannelid: new FormControl({ value: '' }, Validators.required),
      dpa_caseseverityid: ['', Validators.required],
      description: ['', Validators.required],
      dpa_remark: "",
      dpa_casestatusid: ['', Validators.required],
      dpa_resolveddate: "",
      dpa_createdby: "",
      dpa_modifiedby: "",
      dpa_caseowner: "",
      dpa_owningteamid: "",
      dpa_resolveby: "",
      dpa_assignby: "",
      dpa_resolution: "",
      callcenterflag: true,
      dpa_pdpa_flag: false
    });
  }

  async ngOnInit() {
    const thisTs = this
    this.util.ShowWaiting(true)

    this.util.InitValidation()

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.myTeams = JSON.parse(this.cookieData.teams)
    //this.role = JSON.parse(localStorage.getItem("role"))

    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    const url = this.activatedRoute.snapshot['_routerState'].url

    if (url.includes("newCaseForContact")) {
      this.isNewCaseForContactId = true
    }
    else if (url.includes("caseDetail") || (this.guid != null && this.guid.length > 0)) {
      this.isViewMode = true
    }
    else {
      if (url.includes("newCaseChatbot")) {
        this.isNewCaseForChatbot = true
      }
      else{
        this.isAddMode = true
      }
    }

    await this.InitDropdown()

    $("#userIdReceive").on("change", function () {
      thisTs.userIdReceive = $("#userIdReceive").find('option:selected').val()
    })


    $("#ra2")[0].checked = true

    $("#ra1").on("click", function () {
      if (!$(this).checked){
        $("#ra1")[0].checked = true
        $("#ra2")[0].checked = false
      }
    })

    $("#ra2").on("click", function () {
      if (!$(this).checked){
        $("#ra1")[0].checked = false
        $("#ra2")[0].checked = true
      }
    })
  }

  async InitDropdown() {

    if(this.isNewCaseForContactId){
      Observable.forkJoin(
        this.apiService.get("master", "caseChannel"),
        this.apiService.get("master", "caseStatus"),
        this.apiService.get("master", "caseSeverity"),
        this.apiService.get("master", "caseType"),
        this.apiService.get("master", "caseSubType"),
        this.apiService.get("master", "caseSubTypeDetail"),
        this.apiService.get("master", "callcenterTeam"),
        this.apiService.get("crmservice", "contact", "contactid=" + this.id)
      ).subscribe(
        async data => {
  
          this.caseChannelList = data[0]
          let tmp: any = data[1]
          this.caseSeverityList = data[2]
          this.caseTypeList = data[3]
          this.subTypeTmpList = data[4]
          let tmpSubTypeDetail: any = data[5]
          this.teamList = data[6]
          let contactTmps: any = data[7]

          
    let para = ""
    this.teamList.forEach((t: any) => {
      if(para != ""){
        para += "&"
      }     
      para += "callcenterteam=" + t.dpa_callcenterteamid
    });
    this.agentList =  await this.apiService.get("crmservice", "callcenterProfile", para)
  
          this.caseStatusList = tmp.filter((t: any) => {
            return t.dpa_isdisplay
          })
          this.subTypeDetailTmpList = tmpSubTypeDetail.filter((s: any) => {
            return !s.dpa_issendemail
          })
          this.contactList = contactTmps[0];
          await this.initAddModeForContact(contactTmps[0])
  
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );
    }
    else if(this.isViewMode){

      Observable.forkJoin(
        this.apiService.get("master", "caseChannel"),
        this.apiService.get("master", "caseStatus"),
        this.apiService.get("master", "caseSeverity"),
        this.apiService.get("master", "caseType"),
        this.apiService.get("master", "caseSubType"),
        this.apiService.get("master", "caseSubTypeDetail"),
        this.apiService.get("master", "callcenterTeam"),

        this.apiService.get("crmservice", "caseIncident", (this.guid != null && this.guid.length > 0) ? "caseid=" + this.guid : "caseno=" + this.id)
      ).subscribe(
        async data => {

          this.caseChannelList = data[0]
          let tmp: any = data[1]
          this.caseSeverityList = data[2]
          this.caseTypeList = data[3]
          this.subTypeTmpList = data[4]
          let tmpSubTypeDetail: any = data[5]
          this.teamList = data[6]
          let caseInfo: any = data[7]


          let para = ""
          this.teamList.forEach((t: any) => {
            if (para != "") {
              para += "&"
            }
            para += "callcenterteam=" + t.dpa_callcenterteamid
          });
          this.agentList = await this.apiService.get("crmservice", "callcenterProfile", para)

          this.caseStatusList = tmp.filter((t: any) => {
            return t.dpa_isdisplay
          })

          this.subTypeDetailTmpList = tmpSubTypeDetail.filter((s: any) => {
            return !s.dpa_issendemail
          })

          await this.initViewMode(caseInfo)
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );

    }
    else if(this.isNewCaseForChatbot || this.isAddMode){

      Observable.forkJoin(
        this.apiService.get("master", "caseChannel"),
        this.apiService.get("master", "caseStatus"),
        this.apiService.get("master", "caseSeverity"),
        this.apiService.get("master", "caseType"),
        this.apiService.get("master", "caseSubType"),
        this.apiService.get("master", "caseSubTypeDetail"),
        this.apiService.get("master", "callcenterTeam")
      ).subscribe(
        async data => {
  
          this.caseChannelList = data[0]
          let tmp: any = data[1]
          this.caseSeverityList = data[2]
          this.caseTypeList = data[3]
          this.subTypeTmpList = data[4]
          let tmpSubTypeDetail: any = data[5]
          this.teamList = data[6]

          
    let para = ""
    this.teamList.forEach((t: any) => {
      if(para != ""){
        para += "&"
      }     
      para += "callcenterteam=" + t.dpa_callcenterteamid
    });
    this.agentList =  await this.apiService.get("crmservice", "callcenterProfile", para)
  
          this.caseStatusList = tmp.filter((t: any) => {
            return t.dpa_isdisplay
          })
          
          this.subTypeDetailTmpList = tmpSubTypeDetail.filter((s: any) => {
            return !s.dpa_issendemail
          })
  
          await this.initAddMode()
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );
    }
  }

  async createCase(callByNull : boolean = false) {
    let caseId: string
    await this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), callByNull).then((res: any) => {
      
      if (this.util.isSuccessResponse(res)) {
        if (res.incidentid != null && res.incidentid != "") {
          caseId = res.incidentid
        } else {
          this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
          return null
        }
      } else {
        this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
        return null
      }
    })
    return caseId
  }

  async createContact() {
    let caseId: string
    
    this.form.controls["callcenterflag"].setValue(true)
    await this.apiService.post("crmservice", "contact", this.form.getRawValue()).then(async (res: any) => {
      if (this.util.isSuccessResponse(res)) {
        if (res.contactid != null && res.contactid != "") {

          this.form.controls["customerid"].setValue(res.contactid)
          this.form.controls["contactid"].setValue(res.contactid)
          this.form.controls["dpa_casechannelid"].setValue(this.dpa_casechannelid)

          await this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), true).then((res: any) => {
            if (this.util.isSuccessResponse(res)) {
              if (res.incidentid != null && res.incidentid != "") {
                caseId = res.incidentid
              }
              else {
                caseId = null
              }
            }
            else {
              caseId = null
            }
          })
        }
        else {
          caseId = null
        }
      }
      else {
        caseId = null
      }
    })
    return caseId
  }

  async updateCase() {
    var res = await this.apiService.put("crmservice", "caseIncident/" + this.form.get("incidentid").value, this.form.getRawValue());
    if (this.util.isSuccessResponse(res)) {
      return true
    } else {
      this.util.ErrorDialog("แก้ไข Case ไม่สำเร็จ")
      return false
    }
  }

  async updateContact() {
    var res: any = await this.apiService.put("crmservice", "contact/" + this.form.get("contactid").value, this.form.getRawValue());
    if (!this.util.isSuccessResponse(res)) {
      this.util.ErrorDialog("แก้ไข Contact ไม่สำเร็จ")
      return false
    }
    else {
      return true
    }
  }

  async forward() {
    this.submitted = true;
    if ((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
      (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0)) {
      return
    }
    else {
      if (this.form.valid) {

        let caseStatus: any = this.caseStatusList.filter((s: any) => {
          return s.dpa_casestatusid == this.formControl["dpa_casestatusid"].value
        })

        if (caseStatus != null && caseStatus.length > 0 && (caseStatus[0].dpa_name.toLowerCase() == "new" || caseStatus[0].dpa_name.toLowerCase() == "inprogress")) {

          try {
            let caseForwardSubTypeDetail: any = this.subTypeDetailTmpList.filter((st: any) => {
              return st.dpa_casesubtypedetailid == this.formControl["dpa_casesubtypedetailid"].value
            })
            //console.log(caseForwardSubTypeDetail)
            let matchTeam: any = this.teamList.filter((t: any) => {
              return t.dpa_callcenterteamid == caseForwardSubTypeDetail[0].dpa_teamownerid
            })
            if (matchTeam != null && matchTeam.length > 0) {
              this.forwardTeam = caseForwardSubTypeDetail[0].dpa_teamownerid
              await this.onForwardTeamChange()

              let matchUser: any = this.userList.filter((u: any) => {
                return u.dpa_customwebuserid == caseForwardSubTypeDetail[0].dpa_caseownerid
              })
              if (matchUser != null && matchUser.length > 0) {
                this.userIdReceive = caseForwardSubTypeDetail[0].dpa_caseownerid
              }
              else {
                this.userIdReceive = ""
              }
            }
            else {
              this.forwardTeam = ""
            }

          }
          catch (e) {
            console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้")
            this.forwardTeam = ""
            await this.onForwardTeamChange()
            this.userIdReceive = ""

          }

          this.submittedForward = false
          this.forwardRemark = ""
          $("#forwardModal").modal('show')
        }
        else {
          this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น")
        }
      }
    }
  }

  async confirmForward() {
    this.submittedForward = true

    if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
      this.form.controls["dpa_owningteamid"].setValue(this.forwardTeam)
      this.form.controls["dpa_caseowner"].setValue(this.userIdReceive)
      this.form.controls["dpa_assignby"].setValue(this.cookieData.userId)
      this.form.controls["dpa_remark"].setValue(this.forwardRemark)

      this.save(false, true)
    }
  }

  async save(close: boolean = false, closeForward: boolean = false) {
    this.submitted = true;
    if ((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
      (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0)) {
      return
    }
    else {
      if (this.form.valid) {

        //set team
        if(!closeForward){
          if(this.myTeams != null && this.myTeams.length > 0){
            this.formControl["dpa_owningteamid"].setValue(this.myTeams[0].dpa_callcenterteamid)
          }
          else{
            this.formControl["dpa_owningteamid"].setValue(null)
          }
        }//set team

        this.util.ShowWaiting(true)
        if (this.isEditMode) {
          if (await this.updateCase()) {

            if (await this.updateContact()) {
              this.util.ShowWaiting(false)
              this.checkIsSaveCloseCase()
              if (closeForward) {
                $("#forwardModal").modal('hide')
                setTimeout(() => {
                  $("#forwardSuccessModal").modal('show')
                }, 800);
              }
              else if (close) {
                window.close();
              }
              else{
                this.checkIsSaveCloseCase()
                this.isEditMode = true
                this.util.SuccessDialog("แก้ไขสำเร็จ")
              }
            }
            else {
              this.util.ErrorDialog("แก้ไขไม่สำเร็จ")
              this.util.ShowWaiting(false)
            }
          }
          else {
            this.util.ErrorDialog("แก้ไขไม่สำเร็จ")
            this.util.ShowWaiting(false)
          }
        }
        else {
          if (!this.isNewCaseForContactId) {

            //this.form.controls["dpa_casechannelid"].setValue(this.dpa_casechannelid)
            this.form.controls["callcenterflag"].setValue(true)
            //this.form.controls["dpa_pdpa_flag"].setValue(true)
            this.dpa_pdpa_flag = $('#ra1')[0].checked;

            this.form.controls["dpa_pdpa_flag"].setValue(this.dpa_pdpa_flag)
            
            let caseId: string
            await this.apiService.postCustom("crmservice", "contact", this.form.getRawValue()).then(async (res: any) => {
              if (this.util.isSuccessResponse(res)) {
                if (res.contactid != null && res.contactid != "" && res.incidentid != null && res.incidentid != "") {
                  caseId = res.incidentid
                  this.form.controls["contactid"].setValue(res.contactid)
                  this.form.controls["incidentid"].setValue(res.incidentid)
                  this.form.controls["customerid"].setValue(res.customerid)
                }
                else {
                  caseId = null
                }
              }
              else {
                caseId = null
              }
            })

            if (caseId != null) {
              this.guid = caseId
              if( this.dpa_pdpa_flag ){
                $("#ra1")[0].checked = true
                $("#ra2")[0].checked = false
              }else {
                $("#ra1")[0].checked = false
                $("#ra2")[0].checked = true
              }
              this.util.ShowWaiting(false)
              if (closeForward) {
                $("#forwardModal").modal('hide')
                setTimeout(() => {
                  $("#forwardSuccessModal").modal('show')
                }, 800);
              }
              else if (close) {
                window.close();
              }
              else {
                this.checkIsSaveCloseCase()
                this.isEditMode = true
                this.util.SuccessDialog("สร้าง Case สำเร็จ")
                //$('#btnSuccessOK').on('click', function () {
                //  window.location.reload();
                //});
              }
            }
            else {
              if (closeForward) {
                this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
              }
              else {
                this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
              }
              this.util.ShowWaiting(false)
            }
          }
          else {
            await this.createCase(true).then(caseId => {
              this.form.controls["incidentid"].setValue(caseId)

              if (caseId != null) {
                this.util.ShowWaiting(false)
                if (closeForward) {
                  $("#forwardModal").modal('hide')
                  setTimeout(() => {
                    $("#forwardSuccessModal").modal('show')
                  }, 800);
                }
                else if (close) {
                  window.close();
                }
                else {
                  this.checkIsSaveCloseCase()
                  this.util.SuccessDialog("สร้าง Case สำเร็จ")
                  this.isEditMode = true
                }
              }
              else {
                if (closeForward) {
                  this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
                }
                else {
                  this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
                }
                this.util.ShowWaiting(false)
              }
            })
          }
        }
      }
    }
  }

  async initViewMode(caseInfo: any) {
    let channel: any, status: any, severiry: any, caseType: any, caseSubType: any, caseSubTypeDetail: any
    if (caseInfo != null && caseInfo.length > 0) {

      this.mapDataToForm(caseInfo[0])

      channel = this.caseChannelList.filter((c: any) => {
        return c.dpa_name == caseInfo[0].dpa_casechannelidname
      })

      status = this.caseStatusList.filter((c: any) => {
        return c.dpa_code == caseInfo[0].dpa_casestatuscode
      })

      severiry = this.caseSeverityList.filter((c: any) => {
        return c.dpa_name == caseInfo[0].dpa_caseseverityidname
      })

      caseType = this.caseTypeList.filter((c: any) => {
        return c.dpa_name == caseInfo[0].dpa_casetypeidname
      })

      if (caseType != null && caseType.length > 0) {
        this.caseSubTypeList = this.subTypeTmpList.filter(
          (subType: { dpa_casetypeid: any; }) => subType.dpa_casetypeid === caseType[0].dpa_casetypeid)
      }

      caseSubType = this.caseSubTypeList.filter((c: any) => {
        return c.dpa_name == caseInfo[0].dpa_casesubtypeidname
      })

      if (caseSubType != null && caseSubType.length > 0) {
        this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(
          (s: any) => s.dpa_casesubtypeid === caseSubType[0].dpa_casesubtypeid)
      }

      caseSubTypeDetail = this.caseSubTypeDetailList.filter((c: any) => {
        return c.dpa_name == caseInfo[0].dpa_casesubtypedetailidname
      })

      this.isShowAnswerLink = (caseInfo[0].dpa_casechannelidname != null && caseInfo[0].dpa_casechannelidname == "Social")

      this.form.controls["firstname"].setValue(caseInfo[0]["firstname"])
      this.form.controls["lastname"].setValue(caseInfo[0]["lastname"])
      this.form.controls["telephone1"].setValue(caseInfo[0]["telephone1"])
      this.form.controls["dpa_otherphone"].setValue(caseInfo[0]["dpa_otherphone"])
      this.form.controls["emailaddress1"].setValue(caseInfo[0]["emailaddress1"])

      if (caseType != null && caseType.length > 0) {
        this.form.controls["dpa_casetypeid"].setValue(caseType[0]["dpa_casetypeid"])
      }
      if (caseSubType != null && caseSubType.length > 0) {
        this.form.controls["dpa_casesubtypeid"].setValue(caseSubType[0]["dpa_casesubtypeid"])
      }
      if (caseSubTypeDetail != null && caseSubTypeDetail.length > 0) {
        this.form.controls["dpa_casesubtypedetailid"].setValue(caseSubTypeDetail[0]["dpa_casesubtypedetailid"])
      }
      if (channel != null && channel.length > 0) {
        this.form.controls["dpa_casechannelid"].setValue(channel[0]["dpa_casechannelid"])
      }
      if (severiry != null && severiry.length > 0) {
        this.form.controls["dpa_caseseverityid"].setValue(severiry[0]["dpa_caseseverityid"])
      }
      if (status != null && status.length > 0) {
        this.form.controls["dpa_casestatusid"].setValue(status[0]["dpa_casestatusid"])
        if (status[0]["dpa_code"] != null && (status[0]["dpa_code"] == "03" || status[0]["dpa_code"].toLowerCase() == "04")) {
          this.isEndCase = true
          $("#form :input").prop("disabled", true);
          $("#btnKm").prop("disabled", false);
        }
      }

      this.form.controls["description"].setValue(caseInfo[0]["description"])
      this.form.controls["dpa_resolution"].setValue(caseInfo[0]["dpa_resolution"])
      this.form.controls["dpa_remark"].setValue(caseInfo[0]["dpa_remark"])

      this.createdon = caseInfo[0]["createdon"]
      this.modifiedon = caseInfo[0]["modifiedon"]

      this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId)

      this.createBy = caseInfo[0]["dpa_createdbyname"]
      this.modifiedBy = caseInfo[0]["dpa_modifiedbyname"]

      this.dpa_pdpa_flag = caseInfo[0]["dpa_pdpa_flag"]

      if( this.dpa_pdpa_flag ){
        $("#ra1")[0].checked = true
        $("#ra2")[0].checked = false
      }else {
        $("#ra1")[0].checked = false
        $("#ra2")[0].checked = true
      }

      this.form.controls["telephone1"].disable()
      this.onCaseChannelChange()

      if (caseInfo[0].dpa_casestatuscode != null && (caseInfo[0].dpa_caseowner != this.cookieData.dpa_name ||
        caseInfo[0].dpa_casestatuscode == "04" ||
        caseInfo[0].dpa_casestatuscode == "03")) {

        this.isEndCase = true
        $("#form :input").prop("disabled", true);
        $("#btnKm").prop("disabled", false);
      }
      else {
        this.isEditMode = true
        this.form.controls["customerid"].setValue(caseInfo[0]["customerid"])
        this.form.controls["contactid"].setValue(caseInfo[0]["customerid"])
        this.form.controls["incidentid"].setValue(caseInfo[0]["incidentid"])
        this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId)
      }
    }

  }

  async initAddMode() {
    if (this.cookieData.incomingTelephoneNo != null && this.cookieData.incomingTelephoneNo != "") {
      this.form.controls["telephone1"].setValue(this.cookieData.incomingTelephoneNo)

      this.cookieData.incomingTelephoneNo = null
      localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
    }

    let channel = this.caseChannelList.filter((ch: any) => {
      if (this.isNewCaseForChatbot) {
        return ch.dpa_name.replace(" ", "").toLowerCase() == "chatbot"
      }
      else {
        return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter"
      }
    })

    if (channel != null && channel.length > 0) {
      this.dpa_casechannelid = channel[0].dpa_casechannelid
      this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid)
    }

    let status = this.caseStatusList.filter((ch: any) => {
      return ch.dpa_name.replace(" ", "").toLowerCase() == "new"
    })

    if (status != null && status.length > 0) {
      this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid)
    }

    this.createdon = new Date()
    this.modifiedon = new Date()
    this.form.controls["dpa_createdby"].setValue(this.cookieData.userId)
    this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId)
    this.createBy = this.cookieData.dpa_name
    this.modifiedBy = this.cookieData.dpa_name
    this.form.controls["statusreason"].setValue(1)
    this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId)



  }

  async initAddModeForContact(contact: any) {

    this.form.controls["contactid"].setValue(contact["contactid"])
    this.form.controls["customerid"].setValue(contact["contactid"])


    this.form.controls["firstname"].setValue(contact["firstname"])
    this.form.controls["lastname"].setValue(contact["lastname"])
    this.form.controls["telephone1"].setValue(contact["telephone1"])
    this.form.controls["dpa_otherphone"].setValue(contact["dpa_otherphone"])
    this.form.controls["emailaddress1"].setValue(contact["emailaddress1"])

    $(".contact-input").prop("disabled", true)

    let channel = this.caseChannelList.filter((ch: any) => {
      return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter"
    })

    if (channel == null || channel.length > 0) {
      this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid)
    }

    let status = this.caseStatusList.filter((ch: any) => {
      return ch.dpa_name.replace(" ", "").toLowerCase() == "new"
    })

    if (status == null || status.length > 0) {
      this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid)
    }
    this.createdon = new Date()
    this.modifiedon = new Date()
    this.form.controls["dpa_createdby"].setValue(this.cookieData.userId)
    this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId)
    this.createBy = this.cookieData.dpa_name
    this.modifiedBy = this.cookieData.dpa_name
    this.form.controls["statusreason"].setValue(1)
    this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId)
    this.util.ShowWaiting(false)
  }

  get formControl() {
    return this.form.controls;
  }

  get email() {
    return this.form.value.emailaddress1.trim()
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  closeWindow() {
    window.close()
  }

  async onForwardTeamChange() {
    let tmp: any = await this.agentList.filter((a: any) => {
      return a.dpa_teamidlist.map((ag: any) => { return ag.dpa_callcenterteamid }).indexOf(this.forwardTeam) > -1
    })

    this.userList = []
    tmp.forEach((a: any) => {
      if(this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != this.cookieData.userId){
        this.userList.push(a)
      }
    });
  }

  onCaseTypeChange() {
    this.caseSubTypeList = this.subTypeTmpList.filter(
      (subType: any) => subType.dpa_casetypeid === this.form.get("dpa_casetypeid").value)
    this.form.get("dpa_casesubtypeid").setValue("")

    this.onCaseSubTypeChange()
  }

  onCaseSubTypeChange() {
    this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(
      (s: any) => s.dpa_casesubtypeid === this.form.get("dpa_casesubtypeid").value)
    this.form.get("dpa_casesubtypedetailid").setValue("")
  }

  filterByType(type: number) {
    this.util.ShowWaiting(true)
    this.showingKBList = this.kmList.filter(
      (kb: { dpa_knowledgebasetype: any; }) => {
        if (type === kb.dpa_knowledgebasetype) {
          return true
        }
      })
    this.util.ShowWaiting(false)
  }

  filterKm() {
    this.util.ShowWaiting(true)
    this.kmCriteria = $("#kmCri").val()
    if (this.kmCriteria != null && this.kmCriteria.trim().length == 0) {
      this.showingKBList = []
    }
    else {
      this.showingKBList = this.kmList.filter(
        (kb: { dpa_keyword: any; }) => {
          if (kb.dpa_keyword != null && kb.dpa_keyword.includes(this.kmCriteria)) {
            return true
          }
        })
    }
    this.util.ShowWaiting(false)
  }

  onCaseStatusChange() {
    let status = this.caseStatusList.filter((c: any) => {
      return c.dpa_casestatusid == this.form.controls["dpa_casestatusid"].value
    })
    if (status != null && status.length > 0) {

      if (status[0].dpa_code == "04") {
        this.isRemarkRequired = true
      }
      else {
        this.isRemarkRequired = false
      }
      if (status[0].dpa_code == "03") {
        this.isResolvedRequired = true
      }
      else {
        this.isResolvedRequired = false
      }
    }
  }

  mapDataToForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.form.controls[key]) {
        this.form.controls[key].setValue(data[key])
      }
      else {
        this.form.addControl(key, new FormControl(data[key]));
      }
    });
  }

  openKm() {
    const url = this.util.baseUrl() + `/mainmenu/knowledge/`
    window.open(url, '_blank');
  }

  checkIsSaveCloseCase() {
    if (this.isRemarkRequired || this.isResolvedRequired) {
      this.isEndCase = true
      $("#form :input").prop("disabled", true);
      $("#btnKm").prop("disabled", false);
    }
  }

  closeForwardSuccess() {
    $("#forwardSuccessModal").modal('hide')
    setTimeout(() => {
      //this.ngOnInit()
      window.location.reload();
    }, 800);
  }

  onCaseChannelChange(){
    if(this.form.controls["dpa_casechannelid"].value == null || this.form.controls["dpa_casechannelid"].value == ""){
      return
    }
    
    let filtered = this.caseChannelList.filter((c: any) => {
      return this.form.controls["dpa_casechannelid"].value == c.dpa_casechannelid
    })

    if(filtered != null && filtered.length > 0){
      let tmpChannelb = filtered[0].dpa_name.replace(" ", "").toLowerCase()
      if(tmpChannelb != "callcenter"){
        this.form.controls["telephone1"].enable()
        this.form.get('telephone1').clearValidators();   
        $(".lblTelephone").removeClass("required")
        this.form.controls['telephone1'].updateValueAndValidity()
      }
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/new-case/new-case.component.ts